import { CategoryPoint, RecommendedRouteResponse, TransportListIconName, ValidationIssues } from "./custom-route.response";

export interface CustomRoute {
  id: number;
  dailyRoutes: DailyRoute[];
  recommended_route?: RecommendedRouteResponse;
  config?: any;
}

export interface DailyRoute {
  id: number;
  date: Date;
  weatherIconName: string | null; // Weather response or null if not available
  points: Point[];
  startPoint: PointLocation;
  endPoint?: PointLocation;
  endPolylinePath?: PointLocation[]; // Walking geometry from the last POI to endPoint, or back to startPoint when endPoint is null
}

export interface Point {
  id: number;
  type: PointType;
  category: CategoryPoint;
  img: string;
  category_image?: string;
  status: ItemStatus; // 'pending', 'running', 'finished'
  title: Record<string, string>;
  startDate: Date;
  endDate: Date;
  duration: number;
  opening_hours: Record<string, string[]>;
  previousLocation: PointLocation;
  currentLocation: PointLocation;
  polylinesPath: PointLocation[];
  totalTransferDistance: number;
  totalTransferDuration: number;
  transfers: Transfers[];
  transportList: Transport[] | null;
  nextPoint: string;
  transferPathDistances?: any;
  isValid: boolean;
  validationIssues: ValidationIssues[];
  is_saturated?: boolean;
  saturation_label?: string;
  labels?: string[];
  tags?: string[];
  badges?: string[];
}

export type PointType = keyof typeof pointTypeMap;
export const pointTypeMap = {
  'point': 'point',
  'restaurant': 'restaurant', // backend needs to deferentiate between point and restaurant but both are points
  'event': 'event',
  'transport': 'transport', // backend needs to deferentiate between point and transport but both are points
} as const;

export interface Transfers {
  instruction: string,
  distance: number,
  duration: number,
  location: PointLocation,
  mode: string,
  iconName?: TransferIconName 
}

export type TransferIconName = keyof typeof TransferIconNameMap;
export const TransferIconNameMap = {
  straight: 'straight',
  'turn-left': 'turn-left',
  'turn-right': 'turn-right',
  'turn-slight-left': 'turn-slight-left',
  'turn-slight-right': 'turn-slight-right',
  'u-turn-left': 'u-turn-left',
  walk: 'walk', // destination reached
  bike: 'bike',
  bus: 'bus',
  train: 'train',
  subway: 'subway',
} as const;

export interface PointLocation {
  lat: number;
  lng: number;
  address?: string;
  countryCode?: string;
}

export interface Transport {
  id: number;
  name: string; // "Andando", "Bus", "Metro", etc.
  stopDetails: string; // "Line 1", "Line 2", etc.
  duration: number;
  iconName: TransportListIconName;
}

export enum ItemStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  FINISHED = 'finished'
}

export enum RouteStatus {
  CURRENT_DAY_GPS = 'currentDayGps',
  CURRENT_DAY_OFFLINE = 'currentDayOffline',
  FUTURE = 'future',
  PAST = 'past'
}
